import Vue from 'vue'
import * as types from './mutation-types'
import * as R from 'ramda'

export default {
  [types.PUSH_NEW_ORDER] (state, order) {
    state.orderList.push(order)
  },
  [types.SET_ORDER_LIST] (state, orderList) {
    if (!R.equals(orderList, state.orderList)) {
      Vue.set(state, 'orderList', orderList)
    }
  },
  [types.SET_FILTER_CONFIG] (state, filterConfig) {
    Vue.set(state, 'filterConfig', filterConfig)
  },
  [types.UPDATE_ORDER] (state, order) {
    const orderIndex = state.orderList.findIndex(o => o.id === order.id)
    if (orderIndex !== -1) {
      Vue.set(state.orderList, orderIndex, order)
    }
  }
}
